import { DocCard } from '@squareup/dex-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

interface MdxCardProps {
  title?: string;
  icon?: string;
  href?: string;
}

const MdxCard: FC<PropsWithChildren<MdxCardProps>> = ({
  title,
  href,
  icon,
  children,
}) => {
  return (
    <DocCard
      href={href}
      iconPath={icon}
      iconAlt={title || ''}
      trackingId="mdx-card"
    >
      {title && <strong>{title}</strong>}
      {children}
    </DocCard>
  );
};

MdxCard.displayName = 'MdxCard';

interface MdxCardGroupProps {
  cols?: number;
}

const MdxCardGroup: FC<PropsWithChildren<MdxCardGroupProps>> = ({
  cols = 2,
  children,
}) => {
  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: '16px',
      }}
    >
      {children}
    </Box>
  );
};

MdxCardGroup.displayName = 'MdxCardGroup';

export { MdxCard, MdxCardGroup };
